import { call } from "redux-saga/effects";

let getMyBillsModule = null;
export function* getMyBills({ handlingCode = 0, months }) {
  if (!getMyBillsModule) {
    getMyBillsModule = yield call(() => import("./get-my-bills"));
  }
  //llamada a modulo
  yield call(getMyBillsModule.getMyBills, { handlingCode, months });
}

let getBillDetailsModule = null;
export function* getBillDetails(params) {
  if (!getBillDetailsModule) {
    getBillDetailsModule = yield call(() => import("./get-bill-details"));
  }
  yield call(getBillDetailsModule.getBillDetails, params);
  // llamada a modulo
}
let getBillAddressModule = null;
export function* getBillAddress(params) {
  if (!getBillAddressModule) {
    getBillAddressModule = yield call(() => import("./get-bill-address"));
  }
  yield call(getBillAddressModule.getBillAddress, params);
  //llamada modulo
}
let postDuplicateBillModule = null;
export function* postDuplicateBill({ handlingCode = 0, payload }) {
  if (!postDuplicateBillModule) {
    postDuplicateBillModule = yield call(() => import("./post-duplicate-bill"));
  }
  yield call(postDuplicateBillModule.postDuplicateBill, {
    handlingCode,
    payload,
  });
  //llamada modulo
}
let getBillingDateByAccountIdModule = null;
export function* getBillingDateByAccountId({ handlingCode = 0, accountId }) {
  if (!getBillingDateByAccountIdModule) {
    getBillingDateByAccountIdModule = yield call(() =>
      import("./get-billing-date-by-account-id")
    );
  }
  yield call(getBillingDateByAccountIdModule.getBillingDateByAccountId, {
    handlingCode,
    accountId,
  });
  // llamada modulo
}
let getBillsClaimsDataModule = null;
export function* getBillsClaimsData({ handlingCode = 0 }) {
  if (!getBillsClaimsDataModule) {
    getBillsClaimsDataModule = yield call(() =>
      import("./get-bill-claims-data")
    );
  }
  yield call(getBillsClaimsDataModule.getBillsClaimsData, { handlingCode });
  // llamada modulo
}
let getBillDownloadModule = null;
export function* getBillDownload({ handlingCode = 0, payload }) {
  if (!getBillDownloadModule) {
    getBillDownloadModule = yield call(() => import("./get-bill-download"));
  }
  yield call(getBillDownloadModule.getBillDownload, { handlingCode, payload });
  // llamada modulo
}
let modifyBillAddressModule = null;
export function* modifyBillAddress({ handlingCode = 0, payload }) {
  if (!modifyBillAddressModule) {
    modifyBillAddressModule = yield call(() => import("./modify-bill-address"));
  }
  yield call(modifyBillAddressModule.modifyBillAddress, { handlingCode, payload });
  // llamada modulo
}
let postEcoBillModule = null;
export function* postEcoBill(params) {
  if (!postEcoBillModule) {
    postEcoBillModule = yield call(() => import("./post-eco-bill"));
  }
  yield call(postEcoBillModule.postEcoBill, params);
  // llamada modulo
}


let getClaimDetailsModule = null;
export function* getClaimDetails({ billId, code }) {
  if (!getClaimDetailsModule) {
    getClaimDetailsModule = yield call(() => import("./get-claim-details"));
  }
  yield call(getClaimDetailsModule.getClaimDetails, { billId, code })
}

